<template>
  <v-container fluid>
    <v-card>
      <v-card-title>Student</v-card-title>
      <v-card-text>
        <span v-if="student">
          <choose-student
            class="my-2"
            title="Find a student"
            activatorIcon="mdi-magnify"
            @selectedStudent="changeStudent"
          />
          {{student.label}}
        </span>
        <span v-else>
          No student selected, please choose a student
          <br />
          <choose-student
            class="my-2"
            title="Find a student"
            activatorLabel="Search Student"
            activatorIcon="mdi-magnify"
            @selectedStudent="changeStudent"
          />
        </span>
      </v-card-text>
    </v-card>

    <v-card class="mt-5" v-if="student">
      <v-tabs show-arrows v-model="tab" icons-and-text>
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-1">
          Attendance
          <v-icon>mdi-hand</v-icon>
        </v-tab>

        <v-tabs-items class="ma-2" v-model="tab">
          <v-tab-item value="tab-1">
            <v-dialog width="600" v-model="datesDialog">
              <v-card>
                <v-card-title>Choose the date range to view for student's attendance</v-card-title>
                <v-card-text class="text-center">
                  <v-date-picker :max="today" v-model="dates" range></v-date-picker>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-row>
              <v-col cols="12" lg="8">
                <v-text-field
                  @click:prepend="datesDialog = true"
                  @click="datesDialog = true"
                  v-model="dateRangeText"
                  label="Date range"
                  prepend-icon="mdi-calendar"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="4">
                <v-select
                  v-model="selectedCustomDates"
                  :items="customDates"
                  item-value="label"
                  item-text="label"
                  label="Predefined Dates"
                />
              </v-col>
            </v-row>

            <div v-if="report">
              Attended: {{report.total_sessions_attended}} sessions
              Hours: {{report.total_hours}}
              <hr/>
              {{report}}
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
const ChooseStudent = () => import("@/components/reports/ChooseStudent.vue");
import moment from "moment";

export default {
  data() {
    return {
      student: null,
      dates: [],
      datesDialog: false,
      today: new Date().toString(),
      tab: null,
      customDates: [],
      selectedCustomDates: null,
      report: null
    };
  },
  computed: {
    ...mapGetters(["isAppLoading"]),
    dateRangeText() {
      if (this.dates && this.dates.length != 2) {
        return "Choose a date range";
      } else {
        console.log(this.dates);
        const momentDates = this.dates.map(d => moment(d));
        const sortedDates = momentDates.sort(
          (a, b) => a.valueOf() - b.valueOf()
        );
        // const sortedDates = this.dates.sort((a, b) => moment(b).isAfter(moment(a)))
        return sortedDates.map(d => d.format("dddd, MMMM DD YYYY")).join(" ~ ");
      }
    }
  },
  watch: {
    dates(newDates) {
      if (newDates && newDates.length == 2) {
        console.log("date range changed");
        console.log(newDates);
        this.queryAttendance();
      }
    },
    student(s){
      console.log('student changed, querying attendance: ' + s)
        this.queryAttendance();
    },
    selectedCustomDates(label) {
      if (label) {
        const predefined = this.customDates.find(c => c.label == label);
        this.dates = [predefined.start, predefined.end];
      }
    }
  },
  methods: {
    ...mapActions(["addSuccessMessage", "addErrorMessage"]),
    changeStudent(student) {
      this.student = student;
      this.$router.replace({ name: "Student", params: {id: student.id} });
    },
    initDates() {
      const startOfMonth = moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      const endOfMonth = moment()
        .endOf("month")
        .format("YYYY-MM-DD");
      this.dates = [startOfMonth, endOfMonth];

      const dateOptions = [];
      const lastMonth = moment().subtract(1, "months");
      dateOptions.push({
        label: "Last Month",
        start: lastMonth.startOf("month").format("YYYY-MM-DD"),
        end: lastMonth.endOf("month").format("YYYY-MM-DD")
      });
      dateOptions.push({
        label: "Current Month",
        start: startOfMonth,
        end: endOfMonth
      });

      const lastWeek = moment().subtract(1, "week");
      dateOptions.push({
        label: "Last Week",
        start: lastWeek.startOf("week").format("YYYY-MM-DD"),
        end: lastWeek.endOf("week").format("YYYY-MM-DD")
      });
      dateOptions.push({
        label: "Current Week",
        start: moment()
          .startOf("week")
          .format("YYYY-MM-DD"),
        end: moment()
          .endOf("week")
          .format("YYYY-MM-DD")
      });

      this.customDates = dateOptions;
    },
    initStudent(){
      const studentId = this.$route.params.id;
      if(studentId){
        this.$axios.get('student/getById', { params: {studentId: studentId}})
          .then(resp => {
            const response = resp.data.data;
            console.log(response)
            this.student = { id: response.id, label: `${response.firstName} ${response.firstName} (${response.email ? response.email:'no email'})`}
            console.log(`set student`)
          })
      }
    },
    queryAttendance() {
      //check preconditions
      if (this.dates && this.dates.length == 2 && this.student) {
        const params = {
          startDate: this.dates[0],
          endDate: this.dates[1],
          studentId: this.student.id
        };
        this.$axios.get("/report/student/attendance", { params }).then(resp => {
          console.log(resp.data);
          this.report = resp.data;
        });
      }
    }
  },
  mounted() {
    this.initDates();
    this.initStudent();
  },
  components: {
    ChooseStudent
  }
};
</script>

<style>
</style>